require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-leohxj-reason-rollup-starter.json") })
        }
      }, "path---package-unpublished-leohxj-reason-rollup-starter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-leohxj-reason-rollup-starter!./.cache/json/package-unpublished-leohxj-reason-rollup-starter.json
// module id = 950
// module chunks = 231608221292675